import React from "react"
import { useTranslation } from 'react-i18next' 


const titleMap = {
    "products.unit_linked_4_portfolio": [
        "Prudent Portfolio",
        "Moderate Portfolio",
        "Decisive Portfolio",
        "Very Decisive Portfolio",
    ],
    "products.unit_linked_lifecycle": [
        "Prudent Lifecycle",
        "Moderate Lifecycle",
        "Decisive Lifecycle",
    ],
}

const CustomTitleComponent = ({ provider, benefit }) => {
    const { t } = useTranslation()
    let titleKey = "products.saving_insurance"
    
    if (provider) {
        Object.keys(titleMap).forEach((key) => {
            if (titleMap[key].includes(benefit?.name)) {
                titleKey = key
            }
        })
    }

    return (
            <h1>{t(titleKey)}</h1>
    )
}

export default CustomTitleComponent